import findNearestDatumSingleDimension from "./findNearestDatumSingleDimension.js";
export default function findNearestDatumX(_ref) {
  let {
    xScale: scale,
    xAccessor: accessor,
    yScale,
    yAccessor,
    point,
    data
  } = _ref;
  if (!point) return null;
  const nearestDatum = findNearestDatumSingleDimension({
    scale,
    accessor,
    scaledValue: point.x,
    data
  });
  return nearestDatum ? {
    datum: nearestDatum.datum,
    index: nearestDatum.index,
    distanceX: nearestDatum.distance,
    distanceY: Math.abs(Number(yScale(yAccessor(nearestDatum.datum))) - point.y)
  } : null;
}